import moment from "moment";

export const getTime = (date?: Date) => {
  return moment(date).format("HH:mm");
};

export const getPrettyDate = (timeStamp: Date) => moment(timeStamp).format("D MMM YYYY");

export const getPrettyTime = (timeStamp: Date) => moment(timeStamp).format("D MMM YYYY, HH:mm");

export const getPrettyDateTime = (timeStamp: Date) =>
  moment(timeStamp).format("MMMM Do YYYY, h:mm a");

export const getPrettyDateTimeDetailed = (timeStamp: Date) =>
  moment(timeStamp).format("MMMM Do YYYY, HH:mm:ss");

export const getPrettyTimeFromNow = (timeStamp: Date) =>
  // Math.abs so it works for both the past and future
  Math.abs(moment().diff(moment(timeStamp), "days")) < 7
    ? moment(timeStamp).fromNow()
    : getPrettyTime(timeStamp);
